import { ActionIcon, Box, Container, Group, Image, Indicator, createStyles } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { AddShoppingCart, backArrow, cart, logoText, logoicon } from '../assets';
import { ROUTES } from '../config/RoutesName';
import { BookingContext } from '../context/bookingContext';
import { useGlobalContext } from '../context/global-context';
import { leftSideStyle } from '../utils/styles/GlobalStyle';
import NavMenu from './NavMenu';
import { isDevServer } from '../config/Helper';
import { useCartContext } from '../context/cart-context.tsx';

const useStyle = createStyles(() => ({
  showButton: {
    display: 'none',
  },
  donotshowButton: {
    '@media print': {
      display: 'none',
    },
  },
  dropdown: {
    borderRadius: 0,
    top: '75px !important',
    padding: '10px',
  },
  close: {
    color: '#FF8C22',
  },
  header: {
    padding: '30px 10px 20px 20px',
  },
}));

const Header = () => {
  const { classes } = useStyle();
  const navigate = useNavigate();
  const location = useLocation();
  const routePathName = location.pathname;

  const [hideBackButton, setHideBackButton] = useState(false);
  const { classes: leftsideClasses } = leftSideStyle();
  const [hideNavCart, setHideNavCart] = useState(false);
  const [cartIcon, setCartIcon] = useState(cart);
  const [logoCenter, setLogoCenter] = useState(false);
  const { isQuantity, previousQuantity, isItem, setIsItem } = useContext(BookingContext);
  const {
    data: cartData,
    isError: isCartError,
    error,
    isSuccess: isCartSuccess,
    isLoading: isCartLoadng,
    refetch,
    isFetched,
  } = useCartContext();

  const goBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  };
  const [logoPos, setLogoPos] = useState<number>(0);
  useEffect(() => {
    let logo = document.querySelector('.logo')?.getBoundingClientRect();
    setLogoPos(logo?.left || 0);
  }, []);
  useEffect(() => {
    if (routePathName.split('/').includes('order')) {
      setHideBackButton(true);
      setHideNavCart(true);
      setLogoCenter(true);
      setIsItem(false);
    } else {
      switch (routePathName) {
        case ROUTES.HOME:
          setHideBackButton(true);
          setHideNavCart(false);
          setCartIcon(cart);
          setLogoCenter(false);
          break;
        case ROUTES.ORDERDETAILS:
          setHideBackButton(false);
          break;
        case ROUTES.PHONEVERIFY:
        case ROUTES.RECEIPT:
        case ROUTES.ABOUT:
        case ROUTES.FAQ:
        case ROUTES.PRIVACYPOLICY:
        case ROUTES.TERMSCONDITIONS:
          setHideNavCart(true);
          setHideBackButton(false);
          setCartIcon(cart);
          setLogoCenter(true);
          break;
        case ROUTES.CART:
          setCartIcon(AddShoppingCart);
          setHideBackButton(false);
          setHideNavCart(false);
          setLogoCenter(false);
          break;
        // case ROUTES.DETAILS+'/2':
        //   if (cookies['cart-item-count'] >= 1) {
        //     setHideBackButton(true);
        //   }
        //   break;

        default:
          setHideNavCart(false);
          setHideBackButton(false);
          setCartIcon(cart);
          setLogoCenter(false);
          break;
      }
    }
  }, [routePathName]);

  const { cookies } = useGlobalContext();

  const itemCount = cookies['cart-item-count'] || cartData?.data?.items_count;

  return (
    <>
      <Container
        p='20px 15px 20px 20px'
        style={{
          width: '100%',
          position: 'relative',
          zIndex: 2,
          maxWidth: 'unset',
        }}>
        <Group position='apart'>
          <Group align='center'>
            {!hideBackButton && isDevServer() && (
              <ActionIcon
                disabled={routePathName === ROUTES.OTP || routePathName === ROUTES.PAYMENT}
                onClick={() => {
                  if (hideBackButton) {
                    return;
                  } else {
                    goBack();
                  }
                }}
                variant='transparent'>
                <Image
                  className={hideBackButton ? classes.showButton : classes.donotshowButton}
                  width='auto'
                  height='auto'
                  src={backArrow}
                />
              </ActionIcon>
            )}
            <NavLink to={!isDevServer() ? `${ROUTES.HOME}` : ''}>
              <Group
                pl={!logoCenter ? 25 : 0}
                className={
                  logoCenter ? `${leftsideClasses.navLogo} ${leftsideClasses.groupCenter}` : leftsideClasses.navLogo
                }
                position='center'
                spacing='2px'>
                <Image width='auto' height='auto' src={logoicon} />
                <Image width='auto' height='auto' src={logoText} />
              </Group>
            </NavLink>
          </Group>
          <Group
            spacing={30}
            style={{
              flex: 1,
            }}
            position={location.pathname === ROUTES.HOME && !isDevServer() ? 'apart' : 'right'}
            className={leftsideClasses.navLinks}>
            <Group>
              <NavLink
                className={leftsideClasses.horizontalNav}
                to={{
                  pathname: `${ROUTES.CONTACTUS}`,
                }}
                style={{ textDecoration: 'none', color: 'black', ...(hideNavCart ? { display: 'none' } : null) }}>
                Contact Us
              </NavLink>

              <NavLink
                to={{
                  pathname: `${ROUTES.CART}`,
                }}
                style={{ textDecoration: 'none', color: 'black' }}>
                <ActionIcon>
                  <Indicator display='flex' size={12} label={!isNaN(itemCount) ? itemCount : 0} disabled={!itemCount}>
                    <Image
                      className={hideNavCart ? classes.showButton : ''}
                      width='auto'
                      height='auto'
                      src={cartIcon}
                    />
                    ,
                  </Indicator>
                </ActionIcon>
              </NavLink>
            </Group>

            <NavMenu hideNavMenu={hideNavCart && routePathName !== ROUTES.PRIVACYPOLICY} />
          </Group>
        </Group>
      </Container>
    </>
  );
};

export default Header;
